import { useMemo } from 'react';

import { FeatureFlagKeys, NO_KEY, YES_KEY } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks/useCurrentOrganization';
import { useCurrentPlan } from '@/modules/plan/PlanSetup/hooks/useCurrentPlan';
import useReversedFeatureFlag, { PROD_ENV_KEY, UAT_ENV_KEY } from '@/utils/hooks/useFeatureFlag';

const UAT_ORG_IDS = ['1499902', '1499911', '296600', '1507364', '398449'];
const PROD_ORG_IDS = ['3', '28246'];
const ENV = window.REACT_APP_ENV || import.meta.env.REACT_APP_ENV;
export const useFundingMethodsFeatureFlag = () => {
  const { observingOrCurrentOrganizationData } = useCurrentOrganization({ isLoadDefaultOrgData: true });
  const orgPath = useMemo(
    () => observingOrCurrentOrganizationData?.organization_path,
    [observingOrCurrentOrganizationData?.organization_path]
  );

  const checkOrgInList = useMemo(() => {
    if (!orgPath) return () => false;

    const orgIds = orgPath.split('\\').filter((id) => id && id !== '0');
    return (orgList: string[]) => orgList.some((orgId) => orgIds.includes(orgId));
  }, [orgPath]);

  const isOrgInUATList = checkOrgInList(UAT_ORG_IDS);
  const isOrgInProdList = checkOrgInList(PROD_ORG_IDS);

  const currentEnv = ENV;
  const formattedKey = `FEATURE_FLAG: ${FeatureFlagKeys.FUNDING_METHODS}`;
  const currentStorage = localStorage.getItem(formattedKey);

  const shouldHaveAccess =
    (currentEnv === UAT_ENV_KEY && isOrgInUATList) || (currentEnv === PROD_ENV_KEY && isOrgInProdList);

  if (shouldHaveAccess && currentStorage === NO_KEY) {
    localStorage.removeItem(formattedKey);
  }

  if (!shouldHaveAccess && currentStorage === YES_KEY) {
    localStorage.removeItem(formattedKey);
  }

  useReversedFeatureFlag(FeatureFlagKeys.FUNDING_METHODS, {
    dev: true,
    uat: isOrgInUATList,
    prod: isOrgInProdList,
  });

  useCurrentPlan();



  // Show FM for:
  // 1. Templates
  // 2. Plans with tax year 2026+
  // 3. Existing org-based logic
  // return (isTemplate) || (isPlan && isTaxYear2026Plus) || isAvailable;

  // temporary disable ff for prod
  return true;
};
